import { formatNumberToAbsCompactNotation, formatNumberToCompactNotation } from '../../../utils/renderUtils';

interface IProps {
    isLineChart: boolean;
    name: string;
    value: number;
    color: string;
    showNegative?: boolean;
}

export const TooltipSeries = (props: IProps) => {
    const getSymbolClass = () => (props.isLineChart ? 'tooltip-point-line' : 'tooltip-point-circle');

    return (
        <div className="tooltip-series">
            <div className="tooltip-series__left">
                <div style={{ backgroundColor: props.color }} className={getSymbolClass()} />
                <div className="tooltip-series__name">{props.name}:</div>
            </div>
            <div className="tooltip-series__value">
                {props.showNegative ? formatNumberToCompactNotation(props.value) : formatNumberToAbsCompactNotation(props.value)}
            </div>
        </div>
    );
};
